import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { valdiatePage } from "../../global";
import { setLoading } from "../../redux/appSlice";
import { kpiIntervals, saveLocationShop, updateKPIInterval } from "../../services/userservice";

const KPIBurstTime = () => {

    const dispatch = useDispatch();
    const { userInfo, accounts } = useSelector(state => state.appData);

    const history = useHistory();

    const d = {
        accountNo: '',
        interval: '',
    }

    const [data, setData] = useState(d);
    const [grid, setGrid] = useState([]);

    useEffect(() => {
        if (valdiatePage('/kpibursttime')) {
            const load = async () => {
                dispatch(setLoading({ data: true }))
                const rs = await kpiIntervals(accounts);
                dispatch(setLoading({ data: false }))
                if (rs.ok) {
                    setGrid(rs.data);
                }
            }

            load();

        } else {
            history.push('/login');
        }
    }, []);

    const updateData = (key, val) => setData(prev => { return { ...prev, [key]: val } });

    const onSave = async () => {
        if (!data.accountNo) {
            alert('Select Account');
            return;
        }
        if (!data.interval) {
            alert('Select Interval');
            return;
        }

        const z = {
            accountNo: data.accountNo,
            interval: +data.interval,
            userid: +userInfo.id,
        }
        dispatch(setLoading({ data: true }));
        const rs = await updateKPIInterval(z);
        alert(rs.msg);
        if (rs.ok) {
            setData(d);
            const rs2 = await kpiIntervals(accounts);
            if (rs2.ok) {
                setGrid(rs2.data);
            }
        }
        dispatch(setLoading({ data: false }));
    }

    return userInfo && <section className="section">
        <div className="section-header">
            <h1>KPI Burst Time</h1>
        </div>
        <div className="card" style={{ padding: 10 }}>
            <div className="row">
                <div className="col-lg-3">
                    <label>Sub Account</label>
                    <select className="form-select" value={data.accountNo} onChange={(e) => updateData('accountNo', e.target.value)}>
                        <option value="" data-accno="">Select Account</option>
                        {
                            accounts.map((x, index) => <option key={index} value={x}>{x}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg-3">
                    <label>Interval</label>
                    <select className="form-select" value={data.interval} onChange={(e) => updateData('interval', e.target.value)}>
                        <option value="">Select Interval</option>
                        <option value="24">24</option>
                        <option value="36">36</option>
                        <option value="48">48</option>
                        <option value="60">60</option>
                        <option value="72">72</option>
                    </select>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col" style={{ textAlign: 'right' }}>
                    <button type="button" className="btn btn-primary" onClick={onSave}>Save</button>
                </div>
            </div>
            {
                grid && grid.length > 0 &&
                <div className="row mt-3">
                    <div className="col-12">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Account No</th>
                                    <th>KPI Interval</th>
                                </tr>
                                {
                                    grid.map((x, index) =>
                                        <tr key={index}>
                                            <td>{x.AccountNo}</td>
                                            <td>{x.Interval}</td>
                                        </tr>)
                                }
                            </thead>
                        </table>
                    </div>
                </div>
            }
        </div>
    </section >
}

export default KPIBurstTime;